function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.31 4.75L3.41 0l3.8 1.9L9.11 0l1.9 1.9 3.8-1.9-1.9 4.75h-7.6zM12.91 19h-7.6c-5.7 0-4.75-3.8-4.75-3.8s.95-6.65 4.75-8.55h7.6c3.8 1.9 4.75 8.55 4.75 8.55s.95 3.8-4.75 3.8zM4.833 9.975a1.425 1.425 0 102.85 0 1.425 1.425 0 00-2.85 0zm8.55 5.7a1.425 1.425 0 10-2.85 0 1.425 1.425 0 002.85 0zm0-5.843L12.102 8.55l-7.268 7.268L6.136 17.1l7.248-7.268z",
  fill: "#50A684"
});

function SvgGreenCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgGreenCash;